import { res } from "@/BaseComponent";
import { apiService } from "@/services/interceptor";

interface Search {
    isTelegram: number;
    keyword: string;
}
interface GetList {
    page: number;
    size: number;
    searchType: number;
    startDate?: string;
    endDate?: string;
    searchContent: string;
    idxList?: string;
    gubun?: number;
    industry?: number;
}

export interface Data {
    idx: number;
    json: string;
    internalId: string;
    title: string;
    platform: number;
    type: string;
    isActive: number;
    isDoubt: number;
    gubun: number;
    industry: number;
    photoUrl: string;
    country: string;
    language: string;
    category: null;
    cntMembers: number;
    link: string;
    telegramId: number;
    description: string;
    creationDate: number;
    state: number;
    isFavorite: null;
    createDate: number;
    updateDate: number;
    linkForApp: string;
    strGubun: number;
    strIndustry: number;
}

interface DelList {
    idxList: string;
}

interface AddParam {
    title: string;
    platform: number;
    link: string;
    description: string;
    isActive: number;
    isDoubt: number;
    gubun: number;
    industry: number;
}

export default {
    async getResultList(idx: number, param: GetList): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/search/room/result/" + idx, param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },

    async add(param: AddParam): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/search/room/result/add", param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async modify(idx: number, param: AddParam): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/search/room/result/modify/" + idx, param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },

    async delResult(param: number): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/search/room/remove/" + param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async delResultList(param: DelList): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/search/room/result/remove/list", param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async downExcelResult(param: GetList): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/search/room/result/excel/download", param, { responseType: "blob" });
            return response;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getDetailResult(param: number): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/search/room/result/detail/" + param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async delSearch(param: number): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/search/room/remove/" + param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async delSearchList(param: DelList): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/search/room/remove/list", param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async downExcelSearchList(param: GetList): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/search/room/excel/download", param, { responseType: "blob" });
            return response;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },

    async search(param: Search) {
        const res = {} as res;
        try {
            const response = await apiService().post("/search/room/add", param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
    },
    async getSearchList(param: GetList): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/search/room/result", param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getSearchDetail(param: number): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/search/room/result/detail/" + param);
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
};
